<template>
  <div v-if="statement" class="flex gap-x-4">
    <multi-select
      v-model="statement.data.value"
      :options="fetchEnum"
      :searchable="true"
      :can-clear="false"
      :error="errors?.value"
      :disabled="disabled"
      class="grow mt-4"
    />
  </div>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import MultiSelect from '@utils/Multiselect.vue';
import { enumOptionsProvider } from '@utils/table/hooks/provider';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import type { FilterPrototype, LogicStatement, MaybeHydra } from '@/entities/Entities';

interface Props {
  modelValue?: MaybeHydra<
    LogicStatement<{
      value: boolean;
    }>
    >;
  prototype: FilterPrototype<
    { enum: string },
    Record<string, never>
    >;
  errors?: object;
  disabled?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits(['update:modelValue']);
const statement = useVModel(props, 'modelValue', emit, { passive: true });

const { t } = useI18n();

interface Option {
  value: string | null;
  label: string;
}

const fetchEnum = ref<Option[] | undefined>(undefined);

const loadOptions = async () => {
  fetchEnum.value = await enumOptionsProvider(`/enums/${props.prototype.options.enum}`, (el: string) => ({
    label: t(`logicStatement.nullableEnum.${props.modelValue?.name}.${el}`),
    value: el,
  }))();

  fetchEnum.value.unshift({ label: t(`logicStatement.nullableEnum.${props.modelValue?.name}.null`), value: 'null' });
};

loadOptions();

</script>

<style lang="scss" scoped></style>
